import React, { useContext, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardControlKeyIcon from "@mui/icons-material/KeyboardControlKey";
import LogoutIcon from "@mui/icons-material/Logout";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { ListItemIcon } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { appContext } from "../../Context/AppContext";
import { DateTime } from "luxon";

export const Navbar = () => {
  const email = localStorage.getItem("useremail") || "";
  const localData =
    localStorage.getItem("userdata") || JSON.stringify({ accessCode: "" });
  const access_code = JSON.parse(localData).accessCode;
  const {
    department,
    setDepartment,
    location,
    setLocation,
    setFromDate,
    fromDate,
    setToDate,
    toDate,
    monthValue,
    setMonthValue,
  } = useContext(appContext);
  const navigate = useNavigate();
  const [anchorEl1, setAnchorEl1] = useState<null | HTMLElement>(null);
  const [anchorEl2, setAnchorEl2] = useState<null | HTMLElement>(null);
  const [anchorEl3, setAnchorEl3] = useState<null | HTMLElement>(null);
  const [anchorElMonth, setAnchorElMonth] = useState<null | HTMLElement>(null);
  const [firstIcon, setFirstIcon] = useState<"arrow" | "keyboard">("arrow");
  const [secondIcon, setSecondIcon] = useState<"arrow" | "keyboard">("arrow");
  const [thirdIcon, setThirdIcon] = useState<"arrow" | "keyboard">("arrow");
  const [monthIcon, setMonthIcon] = useState<"arrow" | "keyboard">("arrow");

  const handleClickFirstMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl1(event.currentTarget);
  };

  const handleClickMonthMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElMonth(event.currentTarget);
  };

  const handleClickSecondMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleClickThirdMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl3(event.currentTarget);
  };

  const handlelogout = () => {
    localStorage.removeItem("userdata");
    navigate("/login");
  };

  const handleChangePassword = () => {
    handlelogout();
  };

  const handleFirstMenuClose = () => {
    setAnchorEl1(null);
    setFirstIcon("arrow");
  };

  const handleMonthMenuClose = () => {
    setAnchorElMonth(null);
    setMonthIcon("arrow");
  };

  const handleSecondMenuClose = () => {
    setAnchorEl2(null);
    setSecondIcon("arrow");
  };

  const handleThirdMenuClose = () => {
    setAnchorEl3(null);
    setThirdIcon("arrow");
  };

  const toggleFirstIcon = () => {
    setFirstIcon((prevIcon) => (prevIcon === "arrow" ? "keyboard" : "arrow"));
  };

  const toggleMonthIcon = () => {
    setMonthIcon((prevIcon) => (prevIcon === "arrow" ? "keyboard" : "arrow"));
  };

  const toggleSecondIcon = () => {
    setSecondIcon((prevIcon) => (prevIcon === "arrow" ? "keyboard" : "arrow"));
  };
  const toggleThirdIcon = () => {
    setThirdIcon((prevIcon) => (prevIcon === "arrow" ? "keyboard" : "arrow"));
  };
  const handleDepartmentChange = (department: string) => {
    localStorage.setItem("corporate-department", department);
    setDepartment(department);
    toggleFirstIcon();
    handleFirstMenuClose();
  };
  const handleLocationChange = (location: string) => {
    localStorage.setItem("corporate-location", location);
    setLocation(location);
    toggleThirdIcon();
    handleThirdMenuClose();
  };

  const handleMonthChange = (month: string) => {
    let monthFromDate = "";
    let monthToDate = "";
    if (month) {
      const dates = getMonthStartAndEnd(month);
      setFromDate(dates.firstDate);
      setToDate(dates.lastDate);
    }else {
      setFromDate("");
      setToDate("");
    }
    toggleMonthIcon();
    handleMonthMenuClose();
  };

  function getDatesFromAugust2024() {
    const startDate = DateTime.fromObject({ year: 2024, month: 8, day: 1 });
    const endDate = DateTime.now().startOf("month");
    const datesArray = [];

    let currentDate = startDate;
    while (currentDate <= endDate) {
      datesArray.push({
        date: currentDate.toFormat("MMMM yyyy"),
        value: currentDate.toFormat("yyyy-MM-dd"),
      });

      currentDate = currentDate.plus({ months: 1 });
    }

    return datesArray;
  }

  function getMonthStartAndEnd(dateString: string) {
    const startOfMonth = DateTime.fromISO(dateString).startOf("month");
    const endOfMonth = startOfMonth.endOf("month");

    return {
      firstDate: startOfMonth.toFormat("yyyy-MM-dd"),
      lastDate: endOfMonth.toFormat("yyyy-MM-dd"),
    };
  }

  function getMonthName(dateString: string) {
    const date = DateTime.fromISO(dateString);
    return date.toFormat("MMMM yyyy");
  }

  return (
    <AppBar position="fixed" color="secondary">
      <Toolbar>
      {access_code != "army123" &&  <div
          style={{ marginLeft: "320px", display: "flex", alignItems: "center" }}
        >
          <Typography width={120} className="custom-email">
            {monthValue ? getMonthName(monthValue) : "All time"}
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            aria-label="menu"
            onClick={(event) => {
              handleClickMonthMenu(event);
              toggleMonthIcon();
            }}
          >
            {monthIcon === "arrow" ? (
              <KeyboardArrowDownIcon />
            ) : (
              <KeyboardControlKeyIcon />
            )}
          </IconButton>
        { access_code != "army123" &&  <Menu
            anchorEl={anchorElMonth}
            open={Boolean(anchorElMonth)}
            onClose={handleFirstMenuClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            className="custom-menu"
          >
            <MenuItem
              onClick={() => {
                handleMonthChange("");
                setMonthValue("");
              }}
              className="custom-menu-item"
            >
              All time
            </MenuItem>
            {getDatesFromAugust2024().map((el) => (
              <MenuItem
                key={el.value}
                onClick={() => {
                  handleMonthChange(el.value);
                  setMonthValue(el.value);
                }}
                className="custom-menu-item"
              >
                {el.date}
              </MenuItem>
            ))}
          </Menu>}
        </div>}
        {access_code === "ManoSXUno" && (
          <div
            style={{
              marginLeft: "100px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography width={120} className="custom-email">
              {department ? department : "All department"}
            </Typography>
            <IconButton
              edge="end"
              color="inherit"
              aria-label="menu"
              onClick={(event) => {
                handleClickFirstMenu(event);
                toggleFirstIcon();
              }}
            >
              {firstIcon === "arrow" ? (
                <KeyboardArrowDownIcon />
              ) : (
                <KeyboardControlKeyIcon />
              )}
            </IconButton>
            <Menu
              anchorEl={anchorEl1}
              open={Boolean(anchorEl1)}
              onClose={handleFirstMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              className="custom-menu"
            >
              <MenuItem
                onClick={() => handleDepartmentChange("")}
                className="custom-menu-item"
              >
                All department
              </MenuItem>
              <MenuItem
                onClick={() => handleDepartmentChange("LAS")}
                className="custom-menu-item"
              >
                LAS
              </MenuItem>

              <MenuItem
                onClick={() => handleDepartmentChange("Finance")}
                className="custom-menu-item"
              >
                Finance
              </MenuItem>

              <MenuItem
                onClick={() => handleDepartmentChange("ECS1")}
                className="custom-menu-item"
              >
                ECS1
              </MenuItem>

              <MenuItem
                onClick={() => handleDepartmentChange("Mechanical")}
                className="custom-menu-item"
              >
                Mechanical
              </MenuItem>
              <MenuItem
                onClick={() => handleDepartmentChange("SCS")}
                className="custom-menu-item"
              >
                SCS
              </MenuItem>

              <MenuItem
                onClick={() => handleDepartmentChange("PMT")}
                className="custom-menu-item"
              >
                PMT
              </MenuItem>
              <MenuItem
                onClick={() => handleDepartmentChange("Hardware")}
                className="custom-menu-item"
              >
                Hardware
              </MenuItem>

              <MenuItem
                onClick={() => handleDepartmentChange("Management")}
                className="custom-menu-item"
              >
                Management
              </MenuItem>

              <MenuItem
                onClick={() => handleDepartmentChange("INITIA")}
                className="custom-menu-item"
              >
                INITIA
              </MenuItem>
              <MenuItem
                onClick={() => handleDepartmentChange("Manufacturing")}
                className="custom-menu-item"
              >
                Manufacturing
              </MenuItem>

              <MenuItem
                onClick={() => handleDepartmentChange("ECS2")}
                className="custom-menu-item"
              >
                ECS2
              </MenuItem>
              <MenuItem
                onClick={() => handleDepartmentChange("Admin")}
                className="custom-menu-item"
              >
                Admin
              </MenuItem>
              <MenuItem
                onClick={() => handleDepartmentChange("Human Resource")}
                className="custom-menu-item"
              >
                Human Resource
              </MenuItem>

              <MenuItem
                onClick={() => handleDepartmentChange("Costing Cell")}
                className="custom-menu-item"
              >
                Costing Cell
              </MenuItem>

              <MenuItem
                onClick={() => handleDepartmentChange("Software")}
                className="custom-menu-item"
              >
                Software
              </MenuItem>
              <MenuItem
                onClick={() => handleDepartmentChange("Purchase")}
                className="custom-menu-item"
              >
                Purchase
              </MenuItem>
              <MenuItem
                onClick={() => handleDepartmentChange("Material Science")}
                className="custom-menu-item"
              >
                Material Science
              </MenuItem>

              <MenuItem
                onClick={() => handleDepartmentChange("Engineering")}
                className="custom-menu-item"
              >
                Engineering
              </MenuItem>
              <MenuItem
                onClick={() => handleDepartmentChange("Quality")}
                className="custom-menu-item"
              >
                Quality
              </MenuItem>
            </Menu>
          </div>
        )}

        {access_code === "ManoSXUno" && (
          <div
            style={{
              marginLeft: "100px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography width={120} className="custom-email">
              {location ? location : "All location"}
            </Typography>
            <IconButton
              edge="end"
              color="inherit"
              aria-label="menu"
              onClick={(event) => {
                handleClickThirdMenu(event);
                toggleThirdIcon();
              }}
            >
              {thirdIcon === "arrow" ? (
                <KeyboardArrowDownIcon />
              ) : (
                <KeyboardControlKeyIcon />
              )}
            </IconButton>
            <Menu
              anchorEl={anchorEl3}
              open={Boolean(anchorEl3)}
              onClose={handleThirdMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              className="custom-menu"
            >
              <MenuItem
                onClick={() => handleLocationChange("")}
                className="custom-menu-item"
              >
                All location
              </MenuItem>
              <MenuItem
                onClick={() => handleLocationChange("Gurgaon")}
                className="custom-menu-item"
              >
                Gurgaon
              </MenuItem>

              <MenuItem
                onClick={() => handleLocationChange("Pune")}
                className="custom-menu-item"
              >
                Pune
              </MenuItem>

              <MenuItem
                onClick={() => handleLocationChange("Hosur")}
                className="custom-menu-item"
              >
                Hosur
              </MenuItem>

              <MenuItem
                onClick={() => handleLocationChange("Bangalore")}
                className="custom-menu-item"
              >
                Bangalore
              </MenuItem>
              <MenuItem
                onClick={() => handleLocationChange("Chennai")}
                className="custom-menu-item"
              >
                Chennai
              </MenuItem>
            </Menu>
          </div>
        )}
        <div style={{ marginLeft: "auto" }}></div>
        <Typography className="custom-email">{email}</Typography>
        <IconButton
          edge="end"
          color="inherit"
          aria-label="menu"
          onClick={(event) => {
            handleClickSecondMenu(event);
            toggleSecondIcon();
          }}
        >
          {secondIcon === "arrow" ? (
            <KeyboardArrowDownIcon />
          ) : (
            <KeyboardControlKeyIcon />
          )}
        </IconButton>
        <Menu
          anchorEl={anchorEl2}
          open={Boolean(anchorEl2)}
          onClose={handleSecondMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          className="custom-menu"
        >
          {/* <MenuItem onClick={handleChangePassword} className="custom-menu-item">
            <ListItemIcon>
              <PasswordIcon />
            </ListItemIcon>
            Change password
          </MenuItem> */}

          <MenuItem onClick={handlelogout} className="custom-menu-item">
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};
